module.exports = __webpack_public_path__ + "static/media/Floor 1_forklift_sel.113cf784.svg";